module.exports = __webpack_public_path__ + "img/4_2.9807b5b8.png";